import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ArsDashboardCard1 from './components/ArsDashboardCard1'
import Icons from '../../../assets/icons'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import ArsSummarySkeletonLoader from '../../skeletons/ArsDashboardSkeletonLoader'
import { dispatchHandler } from '../../../helper/apiHelperFunctions'
import LanguageTranslator from '../../../locals/LanguageTranslator'
import { getPermissionKey } from '../../../helper/permissions'
import { getMenuMode } from '../../../helper/helperTableFunctions'

const ArsDashboard = ({ jobName, newEngineData }) => {
	const digiArsStore = useSelector((state) => state.digiArsStore)
	const history = useHistory()
	const dispatch = useDispatch();

	const [transferOrderStatusSummary, setTransferOrderStatusSummary] = useState([])
	const [jobRunStatus, setJobRunStatus] = useState({})
	const [lastJobRunData, setLastJobRunData] = useState({})
	const [storeProductAllocation, setStoreProductAllocation] = useState({})
	const [totalReqData, setTotalReqData] = useState({})
	const [jobListSummary, setJobListSummary] = useState([]);

	useEffect(() => {
		dispatchHandler(dispatch, "getSummaryAllJobRequest", {}, getPermissionKey("dashboard", "arsdashboard", "view"));
	}, [])

	useEffect(() => {
		if (digiArsStore?.["getSummaryAllJobData"]?.isSuccess) {
			setJobListSummary(digiArsStore?.["getSummaryAllJobData"]?.data?.resource);
		}
	}, [digiArsStore?.["getSummaryAllJobData"]?.isSuccess])

	function transformTransferOrderSummary(data) {
		const response = data?.response || {};
		return [
			{
				status: "REJECTED",
				total: response.rejected_count || 0,
				pending_qty: response.rejected_qty || 0,
			},
			{
				status: "PENDING",
				total: response.pending_count || 0,
				cancelled_qty: 0,
				rejected_qty: 0,
				approved_qty: 0,
				pending_qty: response.pending_qty || 0,
			},
			{
				status: "CANCELLED",
				total: response.cancelled_count || 0,
				pending_qty: response.cancelled_qty || 0,
			},
			{
				status: "APPROVED",
				total: response.approved_count || 0,
				pending_qty: response.approved_qty || 0,
			},
		];
	}

	useEffect(() => {
		if (digiArsStore.getArsDashboardData?.isSuccess && digiArsStore?.getArsDashboardData?.data) {
			let data = transformTransferOrderSummary(digiArsStore?.getArsDashboardData?.data);
			setTransferOrderStatusSummary(data);
			setLastJobRunData({
				last_job_run_timestamp: digiArsStore?.getArsDashboardData?.data?.lastJobData?.startedon,
				last_job_run_status: digiArsStore?.getArsDashboardData?.data?.lastJobData?.jobrunstate
			})
			setJobRunStatus({
				failedJobs: digiArsStore?.getArsDashboardData?.data?.jobsData?.failed_job_count,
				successfulJobs: digiArsStore?.getArsDashboardData?.data?.jobsData?.success_job_count,
				totalJobsRun: digiArsStore?.getArsDashboardData?.data?.jobsData?.total_job_count,
			})
			setStoreProductAllocation({
				total_product: digiArsStore?.getArsDashboardData?.data?.lastJobAllocationData?.total_product,
				total_store: digiArsStore?.getArsDashboardData?.data?.lastJobAllocationData?.total_store,
				allocation_qty: digiArsStore?.getArsDashboardData?.data?.lastJobAllocationData?.allocation_qty,
			})
			setTotalReqData({
				total_req_qty: digiArsStore?.getArsDashboardData?.data?.lastJobAllocationData?.requirementQty
			})
		}
	}, [digiArsStore.getArsDashboardData?.isSuccess])

	console.log('transferordersummary', transferOrderStatusSummary);

	// function to redirect to differnet pages
	const handleChange = (type) => {
		switch (type) {
			case 'lastJobRunData':
				history.push({
					pathname: getMenuMode?.() == 'new' ? '/app/product/allokator/orders/history' : '/inventoryPlanning/history'
				})
				break;

			case 'jobRunStatusTotal':
				history.push({
					pathname: getMenuMode?.() == "new" ? '/app/product/allokator/orders/history' : '/inventoryPlanning/history'
				})
				break

			case 'jobRunStatusSuccessful':
				history.push({
					pathname: getMenuMode?.() == "new" ? '/app/product/allokator/orders/history' : '/inventoryPlanning/history',
					state: { jobRunState: "SUCCEEDED" },
					datas: { manageRuleId: jobName === "SM-TURNINGCLOUD" ? 1 : 2 }
				})
				break

			case 'jobRunStatusFailed':
				history.push({
					pathname: getMenuMode?.() == "new" ? '/app/product/allokator/orders/history' : '/inventoryPlanning/history',
					state: { jobRunState: "FAILED", manageRuleId: jobName === "SM-TURNINGCLOUD" ? 1 : 2 }
				})
				break

			case 'totalRequirementQty':
				history.push({
					pathname:  getMenuMode?.() == "new" ? '/app/product/allokator/replenishment' :  '/inventoryPlanning/summary',
					search: '?status=%2522SUMMARY%2522',
					states: {
						jobData: {
							manageRuleId: jobName == "SM-AUTO-PURCHASE-ORDERS" ? 3 : jobName === "SM-WAREHOUSE-REPLENISHMENT" ? 1 : 2,
							activeJobName: jobName,
							jobList: jobListSummary, // this is to be integrate with implementation of getAllJob api
							redirectFromDashboard: true
						},
					},
				})
				break
			default:
				break;
		}
	}

	const storeProductAllocationMapping = {
		'total_product': 'Total Product',
		'total_store': 'Total Stores',
		'allocation_qty': 'Total Allocation Qty'
	}
	const storeAllocationUrlMapping = {
		'total_product': 'PRODUCT',
		'total_store': 'SITE',
		'allocation_qty': 'ALLOCATION'
	}

	// func to redirect storeProductAllocation
	const redirectFun = (key) => {
		console.log('redfunc', key);
		history.push({
			pathname:   getMenuMode?.() == "new" ? '/app/product/allokator/replenishment' :  '/inventoryPlanning/summary',
			search: `?status=%2522${storeAllocationUrlMapping[key]}%2522`,
			states: {
				jobData: {
					manageRuleId: jobName == "SM-AUTO-PURCHASE-ORDERS" ? 3 : jobName === "SM-WAREHOUSE-REPLENISHMENT" ? 1 : 2,
					jobList: jobListSummary, // this is to be integrate with implementation of getAllJob api
					activeJobName: jobName,
					redirectFromDashboard: true
				},
			},
		})
	}

	// Define the desired order
	const transferOrderStatusSummaryOrder = ["PENDING", "APPROVED", "REJECTED", "CANCELLED"];

	return (
		<>
			<div className='tcd-tranfer-order'>
				{digiArsStore?.["getArsDashboardData"]?.isLoading ? <ArsSummarySkeletonLoader /> :
					<React.Fragment>
						{/* transferOrderStatusSummary */}
						<div className='flex'>
							{transferOrderStatusSummary?.sort((a, b) => transferOrderStatusSummaryOrder?.indexOf(a?.status) - transferOrderStatusSummaryOrder?.indexOf(b?.status))
								.map((transferOrder) => {
									return <ArsDashboardCard1 jobName={jobName} newEngineData={newEngineData} status={transferOrder.status} pendingQty={transferOrder.pending_qty} totalQty={transferOrder.total} />
								})
							}
						</div>
						<div className='flex p-top-12'>
						{/* lastJobRunData */}
						<div className='tcd-jobs' onClick={() => handleChange('lastJobRunData')}>
							<div className='flex justify-center'>
								{lastJobRunData?.last_job_run_status === 'SUCCEEDED' ? <Icons.GreenTick /> : <Icons.ArsDFailedIcon />}
							</div>
							<LanguageTranslator tag="p" className='p-normal'>Last Job Run Status</LanguageTranslator>
							<LanguageTranslator tag="h3" className={lastJobRunData?.last_job_run_status === 'SUCCEEDED' ? 'h3-succeed' : ''}>{lastJobRunData?.last_job_run_status}</LanguageTranslator>
							<LanguageTranslator tag="p" className='p-normal m-top-10'>{lastJobRunData?.last_job_run_timestamp}</LanguageTranslator>
						</div>
						{/* jobRunStatus */}
						<div className='tcd-status' onClick={() => handleChange('jobRunStatusTotal')}>
							<div className='tcds-left'>
								<LanguageTranslator tag="h1"> {jobRunStatus?.totalJobsRun}</LanguageTranslator>
								<LanguageTranslator tag="p">Total Jobs Run</LanguageTranslator>
							</div>
							<div className='tcds-right'>
								<div className='tcdsr-top' onClick={() => handleChange('jobRunStatusSuccessful')} >
									<LanguageTranslator tag="h1">{jobRunStatus?.successfulJobs}</LanguageTranslator>
									<LanguageTranslator tag="p">Successful Jobs</LanguageTranslator>
								</div>
								<div className='tcdsr-bot' onClick={() => handleChange('jobRunStatusFailed')}>
									<LanguageTranslator tag="h1">{jobRunStatus?.failedJobs}</LanguageTranslator>
									<LanguageTranslator tag="p" className='p-failed'>Failed Jobs</LanguageTranslator>
								</div>
							</div>
						</div>
						{/* storeProductAllocation */}
						{Object.keys(storeProductAllocation).map((key) => {
							return (
								<div className='tcd-jobs' onClick={() => redirectFun(key)}>
									<LanguageTranslator tag="h1">{storeProductAllocation[key]}</LanguageTranslator>
									<LanguageTranslator tag="p">{storeProductAllocationMapping[key]}</LanguageTranslator>
								</div>
							)
						})}
						{/* totalReqData */}
						<div className='tcd-jobs' onClick={() => handleChange('totalRequirementQty')}>
							<LanguageTranslator tag="h1">{totalReqData?.total_req_qty}</LanguageTranslator>
							<LanguageTranslator tag="p">Total Requirement Qty</LanguageTranslator>
						</div>
					</div>
					</React.Fragment>}
			</div>
		</>
	)
}

export default ArsDashboard
